<template>
	<div class="search-item">
		<span>{{ title }}：</span>
		<div
			class="item-list"
			:style="{
				height: isShowMore ? 'auto' : '64px',
			}"
			ref="itemList"
		>
			<span
				:class="currentInd === index ? `search-item_sub active` : `search-item_sub`"
				v-for="(item, index) in dataList"
				:key="item.id"
				:ref="type"
				@click="handleClick(item, index)"
			>
				<span>
					{{ item.name }}
				</span>
			</span>
		</div>
		<div :class="`more ${isShowMore ? 'show-more' : ''}`" v-if="isMore" @click="handleMore">
			<span>{{ isShowMore ? '收起' : '更多' }}</span>
			<span class="iconfont icon-moreandmore-copy"></span>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			default: '',
			type: String,
		},
		type: {
			default: '',
			type: String,
		},
		dataList: {
			default: [],
			type: Array,
		},
		defaultOpen: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			isShowMore: false,
			currentInd: 0,
			isMore: false,
		}
	},
	created() {
		this.isShowMore = this.defaultOpen
	},
	mounted() {
		window.addEventListener('resize', e => {
			this.showMore()
		})
		this.$once('hook:beforeDestroy', () => {
			window.removeEventListener('resize', this.showMore())
		})
		this.$nextTick(() => {
			this.changeIndex()
		})
		window.addEventListener('setItem', e => {
			this.changeIndex(e.newValue)
		})
	},
	watch: {
		dataList() {
			this.$nextTick(() => {
				this.showMore()
				this.changeIndex()
			})
		},
	},
	methods: {
		changeIndex(data) {
			let params = data || localStorage.templateParams
			let id = params ? JSON.parse(params)[`${this.type}`] : 0
			for (let i = 0; i < this.dataList.length - 1; i++) {
				if (id == this.dataList[i].id) {
					this.currentInd = i
					break
				}
			}
		},
		showMore() {
			let list = this.$refs.itemList
			let items = this.$refs[this.type]
			let itemsWidth = 0
			items &&
				items.forEach(item => {
					itemsWidth += item.offsetWidth
				})
			if (list) {
				if (itemsWidth > list.offsetWidth) {
					this.isMore = true
				} else {
					this.isMore = false
				}
			}
		},
		handleMore() {
			this.isShowMore = !this.isShowMore
		},
		handleClick(item, index) {
			this.currentInd = index
			this.$emit('getData', {
				type: this.type,
				id: item.id,
				index,
			})
		},
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.showMore())
	},
}
</script>

<style lang="scss" scoped>
.item-list {
	overflow: hidden;
}
.search-item {
	width: 100%;
	line-height: 64px;
	color: #3b3946;
	font-family: PingFangSC-Medium, PingFang SC;
	font-weight: bold;
	font-size: 14px;
	display: flex;
	padding: 0;
	border-bottom: 1px solid #eeecf5;
	.item-list {
		flex: 1;
		display: flex;
		flex-wrap: wrap;
		.search-item_sub {
			height: 64px;
			border-radius: 4px;
			font-weight: normal;
			font-family: PingFangSC-Regular, PingFang SC;
			cursor: pointer;
			span {
				display: inline-block;
				padding: 6px 14px;
				width: 100%;
				height: 32px;
				line-height: 20px;
			}
			&:hover {
				span {
					color: #5a2df5;
				}
			}
		}
		.active {
			span {
				background-color: #f5f2ff;
				color: #5a2df5;
			}
		}
	}
	.more {
		display: flex;
		justify-content: center;
		align-items: center;
		user-select: none;
		cursor: pointer;
		height: 64px;
		.iconfont {
			margin-left: 6px;
			transform: translateY(-3px);
		}
	}
	.show-more {
		.iconfont {
			transform: rotate(180deg) translateY(-3px);
			box-sizing: border-box;
		}
	}
}
</style>
